import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const HeroSection = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative bg-gray-200 py-32 overflow-hidden">
      {/* Background Image */}
      <div
        className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        style={{
          backgroundImage: "url('/assets/images/bg.png')",
        }}
      >
        {/* Dark overlay to blend image */}
        {/* <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-gray-400/80" /> */}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 flex flex-col items-center text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          "Complete Industrial Solutions,
          <br /> One Trusted Source"
        </h1>
        <p className="font-semibold text-lg text-white max-w-2xl mb-8">
          Fasteners, Cutting tools, Safety gear and other customised industrial
          solution
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/contact"
            className="bg-white hover:bg-blue-50 text-navy font-semibold px-6 py-3 rounded transition"
          >
            Get a Quote
          </Link>
          <a
            href="/Avon_Tools_Brochure.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white hover:bg-blue-50 text-navy font-semibold px-6 py-3 rounded transition"
          >
            Download Brochure
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
